import React from 'react';

import { GeneralLayout } from '@hero/layouts';

export default function Layout({ children }) {
  return <GeneralLayout>{children}</GeneralLayout>;
}
